import {
    approveAndApplyApi,
    cancelTerraformPlanApi,
    getAllProvisionApi,
    getAllServicesApi,
    getAnalyticsByProvisionApi,
    getLogsByProvisionIdApi,
    getTFToJsonApi,
    planTerraformApi,
    terminateDestroyApi,
    terminatePlanApi,
    updateProvisionApi
} from "../../api/provisions/provisionApi";
import { findRegionFromTFJson } from "../../utils/helpers";
import Types from "../types";
import { setGlobalLoader, showSnackbar } from "./commonAction";

export const getTFtoJson = (service) => {
    return async function (dispatch) {
        const result = await getTFToJsonApi(service)
        dispatch({
            type: Types.TF_TO_JSON,
            payload: result?.tfTojson
        });
        dispatch({
            type: Types.TERRAFORM_REGION,
            payload: findRegionFromTFJson(result?.tfTojson)
        })
    }
}

export const setNewProvision = (newProvision) => {
    return async function (dispatch) {
        dispatch({
            type: Types.PROVISION_ADD_NEW,
            payload: newProvision
        })
    }
}

export const planTerraform = (payload) => {
    return async function (dispatch) {
        await planTerraformApi(payload);
        dispatch(getAllProvision())
    }
}

export const updateProvision = (id, payload) => {
    return async function (dispatch) {
        await updateProvisionApi(id, payload);
        dispatch(getAllProvision())
    }
}

export const getAllServices = () => {
    return async function (dispatch) {
        dispatch(setGlobalLoader(true))
        const result = await getAllServicesApi()
        dispatch({
            type: Types.ALL_SERVICES,
            payload: result
        });
        dispatch(setGlobalLoader(false))
    }
}

export const cancelTerraformPlan = (payload) => {
    return async function (dispatch) {
        const result = await cancelTerraformPlanApi(payload)
        if (result) {
            dispatch(
                showSnackbar({
                    message: result,
                    severity: "success",
                    open: true,
                })
            )
        }
        dispatch(getAllProvision())
    }
}

export const approveAndApply = (payload) => {
    return async function (dispatch) {
        await approveAndApplyApi(payload)
        dispatch(getAllProvision())
    }
}

export const getAllProvision = () => {
    return async function (dispatch) {
        dispatch(setGlobalLoader(true))
        const result = await getAllProvisionApi()
        if (result) {
            dispatch({
                type: Types.PROVISION_ALL_OPERATIONS,
                payload: result
            })
            return true
        }
        dispatch(setGlobalLoader(false))
    }
}

export const terminatePlan = (payload) => {
    return async function (dispatch) {
        await terminatePlanApi(payload)
        dispatch(getAllProvision())
    }
}

export const terminateDestroy = (payload) => {
    return async function (dispatch) {
        await terminateDestroyApi(payload)
        dispatch(getAllProvision())
    }
}

export const getLogsByProvisionId = (provisionId) => {
    return async function (dispatch, getState) {
        dispatch(setGlobalLoader(true));
        const result = await getLogsByProvisionIdApi(provisionId)
        const { logs } = getState()?.provision
        const updatedLogs = { ...logs, ...{ [provisionId]: result?.actions } }
        dispatch({
            type: Types.PROVISION_LOGS,
            payload: updatedLogs
        })
        dispatch(setGlobalLoader(false));
        return updatedLogs
    }
}

export const getAnalyticsByProvision = (provisionId) => {
    return async function (dispatch, getState) {
        const result = await getAnalyticsByProvisionApi(provisionId)
        const { allCostAndSecurity } = getState()?.provision
        dispatch({
            type: Types.PROVISION_COST_AND_SECURITY,
            payload: { ...allCostAndSecurity, ...{ [provisionId]: result } }
        })
        return result;
    }
}
